<template>
  <div class="adjust-price-list">
    <div class="adjust-price-list-nav">
      <div
        class="adjust-price-list-nav-item"
        :class="{ active: activeNav === item.id }"
        v-for="item in navList"
        :key="item.id"
        @click="onNavClick(item.id)"
      >
        <span>{{ item.name }}</span>
      </div>
    </div>
    <div class="adjust-price-list-order-list">
      <van-list
        v-model="orderInfo.loading"
        :finished="orderInfo.finished"
        finished-text=""
        @load="onOrderListLoad"
      >
        <div
          class="adjust-price-list-order-list-card"
          :class="{ 'can-select': activeNav === 0 }"
          v-for="(item, index) in orderInfo.list"
          :key="index"
          @click="onSelectItem(item)"
        >
          <div class="radio-container" v-if="activeNav === 0">
            <div class="c-select-item-radio" :class="{ active: item.selected }">
              <img
                class="checked-icon"
                src="../../assets/icons/checked.svg"
                alt=""
              />
            </div>
          </div>
          <div>
            <OrderItemCard
              :adjustPrice="true"
              :index="index"
              :data="item"
              :status="item.status"
              :canModifyPrice="true"
              :isLast="true"
              @click.stop
            />
          </div>
        </div>
        <div
          class="adjust-price-list-order-list-empty"
          v-if="orderInfo.list.length === 0"
        >
          <Empty :text="showEmptyText" />
        </div>
      </van-list>
    </div>

    <div
      class="adjust-price-list-bottom-btn-container c:row-between-center"
      v-if="activeNav === 0"
    >
      <van-button
        class="w100"
        :class="{ disabled: selectedIds.length === 0 }"
        @click.native="onRejectAdjust"
        >驳回
      </van-button>
      <van-button
        class="w100"
        :class="{ disabled: selectedIds.length === 0 }"
        type="primary"
        @click.native="onApproveAdjust"
        >批准
      </van-button>
    </div>
    <van-dialog
      v-model="showApprovePopup"
      title="确认批准调价？"
      :show-confirm-button="false"
    >
      <div class="modal-text-container"></div>
      <div class="modal-btns c:row-between-center">
        <van-button
          class="w100"
          @click.native="() => (showApprovePopup = false)"
          >取消
        </van-button>
        <van-button class="w100" type="primary" @click="onApproveAdjustSubmit"
          >确定
        </van-button>
      </div>
    </van-dialog>
    <van-dialog
      v-model="showRejectPopup"
      title="驳回理由"
      :show-confirm-button="false"
    >
      <div class="modal-text-container">
        <textarea
          placeholder="请输入驳回理由"
          rows="4"
          class="w100 modal-text"
          v-model="rejectRemark"
          maxlength="200"
        ></textarea>
      </div>
      <div class="modal-btns c:row-between-center">
        <van-button class="w100" @click.native="() => (showRejectPopup = false)"
          >取消
        </van-button>
        <van-button
          class="w100"
          type="primary"
          :disabled="!rejectRemark"
          @click="onRejectAdjustSubmit"
          >确定
        </van-button>
      </div>
    </van-dialog>
  </div>
</template>
<script>
  import OrderItemCard from '@/components/order/widgets/OrderItemCard.vue'
  import Empty from '@/components/common/Empty.vue'
  import { orderAdjustPricePage, auditAdjustPriceApi } from '@/api'

  export default {
    components: {
      OrderItemCard,
      Empty
    },
    data() {
      return {
        activeNav: 0,
        navList: [
          {
            id: 0,
            name: '待审批'
          },
          {
            id: 1,
            name: '已批准'
          },
          {
            id: 2,
            name: '已驳回'
          }
        ],
        orderInfo: {
          loading: false,
          finished: false,
          params: {
            pageNum: 1,
            pageSize: 10,
            approveStatus: 0,
            sort: undefined,
            asc: undefined
          },
          list: []
        },
        showApprovePopup: false,
        showRejectPopup: false,
        rejectRemark: ''
      }
    },
    computed: {
      showEmptyText() {
        let text = ''
        switch (this.activeNav) {
          case 1:
            text = '暂无待审批的商品'
            break
          case 2:
            text = '暂无已批准的商品'
            break
          case 3:
            text = '暂无已驳回的商品'
            break
        }
        return text
      },
      selectedIds() {
        return this.orderInfo.list
          .filter(item => item.selected)
          .map(item => item.id)
      }
    },
    mounted() {
      this.orderAdjustPricePageApi()
    },
    methods: {
      onNavClick(id) {
        this.activeNav = id
        this.orderInfo.params.approveStatus = id
        this.orderInfo.list = []
        this.orderInfo.loading = false
        this.orderInfo.finished = false
        this.orderAdjustPricePageApi()
      },
      onSelectItem(item) {
        item.selected = !item.selected
      },
      onApproveAdjust() {
        this.showApprovePopup = true
      },
      onApproveAdjustSubmit() {
        if (this.selectedIds.length === 0) {
          this.$toast('请选择要驳回的商品')
          return
        }
        this.$toast.loading({
          message: '加载中',
          forbidClick: true
        })
        const params = {
          orderAdjustPriceIds: this.selectedIds,
          status: 1
        }
        auditAdjustPriceApi(params).then(() => {
          this.showApprovePopup = false
          this.$toast.success('批准成功')
          this.orderInfo.list = []
          this.orderInfo.loading = false
          this.orderInfo.finished = false
          this.orderInfo.params.pageNum = 1
          this.$toast.clear()
          this.orderAdjustPricePageApi()
        })
      },
      onRejectAdjust() {
        this.showRejectPopup = true
        this.rejectRemark = ''
      },
      onRejectAdjustSubmit() {
        if (this.selectedIds.length === 0) {
          this.$toast('请选择要驳回的商品')
          return
        }
        if (!this.rejectRemark) {
          this.$toast('请输入驳回理由')
          return
        }
        this.$toast.loading({
          message: '加载中',
          forbidClick: true
        })
        const params = {
          orderAdjustPriceIds: this.selectedIds,
          status: 2,
          rejectRemark: this.rejectRemark
        }
        auditAdjustPriceApi(params).then(() => {
          this.showRejectPopup = false
          this.$toast.success('驳回成功')
          this.orderInfo.list = []
          this.orderInfo.loading = false
          this.orderInfo.finished = false
          this.orderInfo.params.pageNum = 1
          this.$toast.clear()
          this.orderAdjustPricePageApi()
        })
      },
      onOrderListLoad() {
        console.log('onOrderListLoad')
        this.orderInfo.params.pageNum++
        this.orderAdjustPricePageApi()
      },
      async orderAdjustPricePageApi() {
        this.orderInfo.loading = true
        const res = await orderAdjustPricePage(this.orderInfo.params)
        if (!res.data || res.data.length === 0) {
          this.orderInfo.finished = true
          return
        }
        res.data.forEach(item => {
          item.selected = false
        })
        this.orderInfo.list = [...this.orderInfo.list, ...res.data]
        this.orderInfo.loading = false
        this.orderInfo.finished = !res.hasMore
      }
    }
  }
</script>
<style lang="less" scoped>
  .adjust-price-list {
    height: 100%;
    background-color: #f1f2f4;
    display: flex;
    flex-direction: column;
    &-nav {
      display: flex;
      padding: 0 10/20rem;
      height: 40/20rem;
      background-color: #fff;
      box-sizing: border-box;
      border-top: 1px solid #e4e4e4;
      border-bottom: 2px solid #e4e4e4;
      &-item {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        font-weight: 500;
        color: #7d7d7d;
        &.active {
          position: relative;
          color: #000;
          &::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 76/20rem;
            height: 2px;
            background-color: #000;
          }
        }
      }
    }
    &-order-list {
      flex: 1;
      height: 0;
      overflow-y: auto;
      ::-webkit-scrollbar {
        display: none;
      }
      padding-top: 4/20rem;
      &-card {
        position: relative;
        border-bottom: 3/20rem solid #e4e4e4;
        &.can-select {
          padding-left: 38/20rem;
        }
        padding-left: 20/20rem;
        padding-right: 20/20rem;
        background-color: #fff;

        .radio-container {
          position: absolute;
          left: 8/20rem;
          top: 16/20rem;
          width: 22/20rem;
          height: 130/20rem;
          display: flex;
          align-items: center;
          justify-content: center;
          .c-select-item-radio {
            border: 2/20rem solid #dcdddf;
            width: 22/20rem;
            height: 22/20rem;
            border-radius: 50%;

            .checked-icon {
              box-sizing: border-box;
              width: 100%;
              height: 100%;
              display: none;
            }

            &.active {
              border-color: #000;
              .checked-icon {
                display: block;
              }
            }
          }
        }
      }
    }
    &-bottom-btn-container {
      width: 100%;
      height: 96/20rem;
      padding: 0 1rem;
      gap: 12/20rem;
    }
    .disabled {
      pointer-events: none;
      opacity: 0.35;
    }
    .modal-text-container {
      padding: 1rem 0;
      .modal-text {
        padding: 12/20rem 10/20rem;
        font-size: 14px;
        line-height: 20px;
      }
    }
    .modal-btns {
      gap: 12/20rem;
    }
  }
</style>
